/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftUpIcon20Solid = forwardRef('ArrowDCornerLeftUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.116 6.366a1.25 1.25 0 1 0 1.768 1.768L6.25 4.768V14A3.75 3.75 0 0 0 10 17.75h7.5a1.25 1.25 0 1 0 0-2.5H10c-.69 0-1.25-.56-1.25-1.25V4.768l3.366 3.366a1.25 1.25 0 0 0 1.768-1.768l-4.44-4.44a2.75 2.75 0 0 0-3.889 0l-4.439 4.44Z" })));
});
